export const UNPAID_ORDERS_WARNING =
  "exhibitor.cart.payment.unpaid_orders_warning";

export const MULTIPLE_ORDER_ALERT = {
  message: "exhibitor.cart.payment.multiple_order_alert.message",
  buttonText: "exhibitor.cart.payment.multiple_order_alert.button_text",
} as const;

export const ATTEMPTS_BEFORE_SKIP_PAYMENT = 2;
